// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 838) return "js/838.js";
	if (chunkId === 315) return "js/315.js";
	// return url for filenames based on template
	return undefined;
};